import axios from "axios";

export const getUserSessionId = async (payload) => {
  try {
    let {data} = await axios.get(
      `${window._env.REACT_APP_EMCONSOLE_API_URL}/v1/user/${payload.sub}`,
    );
    return data;
  } catch (err) {
    console.log("error while update user  profile in  keyclock", err.message);
    return {
      message: "Server Not responding! plese try after some time",
      status: 409,
    };
  }
};
